<template>
  <div class="info-bar-container">
    <div class="info-bar">
      <div class="mini-map">
        <router-link to="/">FTC</router-link>
        <span><img @contextmenu.prevent src="../assets/spacer.png"><img @contextmenu.prevent src="../assets/spacer.png">
        >
        <img @contextmenu.prevent src="../assets/spacer.png"><img @contextmenu.prevent src="../assets/spacer.png"></span>
        <slot></slot>
      </div>

      <!-- <div class="info-bar-end">
        <img @contextmenu.prevent class="lang-button" src="../assets/vi_VN.png" @click="langChangeVn">
        <img @contextmenu.prevent class="lang-button" src="../assets/en_US.png" @click="langChangeEn">
        <button @click="toLogin">{{ $store.getters['home/finalCl1Title'] }}</button>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    langChangeVn () {
      this.$store.commit('changeLangVn')
    },
    langChangeEn () {
      this.$store.commit('changeLangEn')
    },
    toLogin () {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
  .info-bar-container {
    width: 100%;
    margin-bottom: 15px;
  }

  .info-bar-container .info-bar {
    padding: 0px 10px;
    width: 100%;
    height: 40px;
    background-color: #eefaff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
  }

  .info-bar-end {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 160px;
  }

  .info-bar-end button {
    border: none;
    background: #fff;
    width: 100px;
    height: 25px;
    cursor: pointer;
  }

  .mini-map a{
    text-decoration: none;
    color: rgb(28, 108, 193);
    font-weight: 700;
  }

  .mini-map span {
    font-weight: 800;
  }

  .lang-button {
    cursor: pointer;
  }

  @media (max-width: 510px) {
    .info-bar-container .info-bar {
      height: 60px
    }
  }

  @media (max-width: 370px) {
    .info-bar-container .info-bar {
      height: 80px
    }
  }
</style>
